<template>
  <router-link
    tag="div"
    class="col product--landing"
    :to="{ name: 'productPreview', params: { id: product._id } }"
  >
    <b-row>
      <b-col>
        <div
          class="image--landing"
          :style="imageStyle"
          :title="product.styleName"
          v-if="product.thumbnailPath"
        />
        <div v-else class="noImage--landing">No image</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="price--landing"> From ${{ product.basePrice }} </b-col>
    </b-row>
    <b-row>
      <b-col class="name--landing">
        {{ product.styleName }}
      </b-col>
    </b-row>
  </router-link>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const manageUserStore = namespace('manageUserStore')

@Component({})
export default class LandingPageCategoryProduct extends Vue {
  @manageUserStore.Action('setPrevUrl') actionSetPrevUrl
  @Prop({ type: Object, required: true, default: null }) product

  get imageStyle() {
    let image = ''
    if (this.product.thumbnailPath && this.product.thumbnailPath) {
      image = this.product.thumbnailPath
    }
    return { backgroundImage: `url(${image})` }
  }
  mounted() {
    this.saveUrl()
  }
  saveUrl() {
    this.actionSetPrevUrl(window.location.href)
  }
}
</script>

<style lang="scss" >
.product--landing {
  box-sizing: content-box;
  color: #090909;
  cursor: pointer;
  margin-bottom: 95px;
  max-width: 301px !important;
  &.col {
    padding-right: 13px;
    padding-left: 12px;
  }
}

.image--landing,
.noImage--landing {
  height: 301px;
  width: 301px;
}
.image--landing {
  background-position: center center;
  background-size: cover;
}
.noImage--landing {
  align-items: center;
  background-color: #bbb;
  display: flex;
  justify-content: center;
  text-align: center;
}
.price--landing {
  font-size: rem(15px);
  font-weight: 500;
  letter-spacing: 1.05px;
  padding-top: 15px;
  text-transform: uppercase;
}
.name--landing {
  font-family: $secondary-font;
  font-size: rem(24px);
  font-weight: 900;
  text-transform: uppercase;
}
</style>
